import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-bottom-filters',
  templateUrl: './bottom-filters.component.html',
  styleUrls: ['./bottom-filters.component.scss',],
})
export class BottomFiltersComponent {

  @Output() applyFilterEvent = new EventEmitter<any>();

  constructor() { }

  onApplyFilters(params: any) {
    this.applyFilterEvent.emit({ ...params, page: 1, });
  }


}
